import Vue from 'vue'
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

import WebpartTemplate from '@webparts/components/webparts/base/WebpartTemplate.vue'
import WebpartBase from '@webparts/components/webparts/base/WebpartBase'
import { LoadingBar } from '@appbase/components/loading'
import NoData from '@webparts/components/common/NoData.vue'
import RandomImageSettingModal from './RandomImageSettingModal.vue'

import api from '@webparts/api'

import * as accouttypes from '@account/store/types'
import * as urlHelper from '@appbase/util/url-helper'
import { buildStyle } from "@appbase/util/popup-helper"

const tempData: kyobobook.Image = {
    webpartId: '',
    title: '',
    image: '/cm/gres/faux/images/portal/img-thumbnail03.png',
    linkUrl: 'https://www.kyobobook.co.kr/',
    order: 1,
    isUse: true
}

@Component({
    name: 'kbb-random-image-webpart',
    components: { 
        LoadingBar,
        NoData,
        WebpartTemplate,
        RandomImageSettingModal
    },
    computed: mapGetters({
        current: accouttypes.CURRENT,
    }),
})
export default class RandomImageWebpart extends Mixins(WebpartBase) {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //
    @Prop({ type: Object }) webpart!: webpartv3.Webpart

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    current!: account.TCurrent;

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //
    options: any = null;

    image: string = '';
    curImage: kyobobook.Image | null = null;

    isImageManager: boolean = false;

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
	// 웹파트 옵션 저장값 set
	setProps() {
		this.options =
		typeof this.webpart.props == typeof '' ? JSON.parse(this.webpart.props as string) : this.webpart.props;
    }

    openSettingModal(){
        const modal: appbase.IModalOpenable = this.$refs['modal'] as any
        const options: appbase.TModalInfo<any> = {
            component: RandomImageSettingModal,
            props: { webpartId: this.webpart.id },
            events: {
                cancel: () => {
                    modal.closeModal();
                },
            },
        }
        modal.openModal(options)
    }

    load() {
        this.loading = true;

        if(this.current.permissions.roles.length>0){
            this.isImageManager = this.current.permissions.isCompanyManager || this.current.permissions.isSuperAdmin
        }

        if(this.webpart.id) {
            api.kyobobook.getRandomImageInfo(this.webpart.id).then((res) => {
                this.curImage = res;
                this.loading = false;
            });
        } else {
            this.loading = false;
        }
    }

    getImageSource(fileName: string) {
        return `/cm/Webpart/WebpartImage/api/getImageFile?fileName=${encodeURIComponent(fileName)}`;
    }

    async handleClick(link: string) {
        if (this.preview) return;

        var url = link;
        var features = ''
        var target = '_blank'

        if (url.includes('api/processToken')) {
            var _url = new URL(url)

            var searchParams = _url.searchParams

            var redirect = searchParams.get("redirectUrl") ?? "_blank"
            _url.searchParams.delete("redirectUrl")

            var search: string[] = []
            search.push(`personCode=${this.current.user.personCode}`, `timeStamp=${new Date().getTime()}`)
            if (_url.search !== '') {
                var _search = _url.search.slice(1).split('&')
                search = search.concat(_search)
            }
            var params = this.getParams(search)

            url = this.isTeams ? await urlHelper.redirectWithProcessToken(redirect, params, this.current.user.comCode, this.current.key)
                : `${window.location.origin}${process.env.NODE_ENV === 'production' ? '/po' : ''}${redirect}`;
            target = redirect
            features = buildStyle({ width: 900, height: 800 })
        }
        else if (url.includes(window.location.host)) {
            window.location.href = url
            return
        }

        window.open(url, target, features);
    }

    getParams(search: string[]) {
        var res = ''

        for (var i = 0; i < search.length; i++) {
            res += `&${search[i]}`
        }

        if (res.startsWith('&'))
            res = res.slice(1)

        return res
    }
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: W A T C H E S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    @Watch('webpart.props')
    changeWebpartValue() {
        this.setProps();
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E S T Y L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //
    created() {
		if (this.webpart && this.webpart.props) {
			this.setProps();
		}

		if (this.preview) {
            this.curImage = tempData;
		} else {
			this.load();
		}
    }
}